import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, LOGO_URL } from "../lib/api";
import { Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (_) {
      setSent(true); // intentionally same message to avoid email enumeration
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="forgot-password-page" className="min-h-[80vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md border border-white/10 p-8 lg:p-10 bg-[#0E0E0E]">
        <img src={LOGO_URL} alt="MileForge" className="h-14 w-auto object-contain mb-3 -ml-3" />
        <div className="overline mb-1">Account Recovery</div>
        <h1 className="font-display text-3xl uppercase tracking-tight">Reset Password</h1>

        {sent ? (
          <div data-testid="forgot-sent" className="mt-7 border border-[#D96A1B]/30 bg-[#D96A1B]/10 p-5">
            <Mail size={20} className="text-[#D96A1B]" />
            <p className="mt-3 text-sm font-body text-white/80 leading-relaxed">
              If <span className="text-[#D96A1B]">{email}</span> is registered, a reset link is on its way. Check your inbox (and spam folder) within a few minutes. The link expires in 15 minutes.
            </p>
            <Link to="/signin" className="btn-ghost mt-5 inline-flex w-full justify-center">Back to Sign In</Link>
          </div>
        ) : (
          <>
            <p className="text-sm text-white/55 font-body mt-2">
              Enter your account email. We'll send you a link to set a new password.
            </p>
            <form onSubmit={submit} className="mt-7 space-y-4">
              <div>
                <label className="overline block mb-2">Email</label>
                <input
                  data-testid="forgot-email"
                  required type="email" value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@email.com"
                  className="w-full bg-[#111] border border-white/15 px-4 py-3 focus:outline-none focus:border-[#D96A1B] font-body"
                />
              </div>
              <button data-testid="forgot-submit" disabled={loading} className="btn-orange w-full justify-center">
                {loading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>
            <p className="mt-6 text-sm font-body text-white/60 text-center">
              Remembered it? <Link to="/signin" data-testid="forgot-back-signin" className="text-[#D96A1B] hover:underline">Sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
